import { styled } from "@mui/material/styles";

export const HeaderContainer = styled("header")(({ theme }) => ({
  background: theme.palette.primary.main,
  padding: theme.spacing(3, 0, 3, 0),
  paddingLeft: `env(safe-area-inset-left)`,
}));
